<template>
  <div class="admin-pis__summary__list">
    <div class="admin-pis__summary__head">
      <span class="data">{{ type === 'normal' ? 'Normal' : 'Priority' }} Queue</span>
    </div>
    <div
      v-for="entry in queue"
      :key="entry.id"
      class="admin-pis__summary__item"
    >
      <div class="data-group">
        <span class="data data--highlight">{{ entry.counter.short_name }}</span>
        <span class="data data--highlight">{{ entry.current_count }}</span>
        <span class="data data--highlight">{{ entry.counter.group.name }}</span>
        <span class="data data--highlight">{{ entry.status }}</span>
        <span class="data data--highlight">{{ entry.start_at | moment('hh:mm A') }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      required: false,
      default: 'normal',
    },
  },
  computed: {
    queue () {
      return this.$store.getters['queueing/' + this.type]
    },
  },
  async created () {
    await this.$store.dispatch('queueing/getList', this.type)
  },
}
</script>
